import {useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import {filterBasicTypes} from '@adv-mt/mt-filter-basic'
import FilterWrapperBasic, {filterWrapperBasicTypes} from '@adv-mt/mt-filter-wrapper-basic'

import {getInitialValue} from '../utils.js'

const filterName = 'seats'

export const SeatsFilter = ({options, onChange, value}) => {
  const [selectedSeatsOption, setSelectedSeatsOption] = useState(
    getInitialValue({options, value: value?.id ? [value.id] : []})
  )

  useEffect(() => {
    const [selectedId] = selectedSeatsOption
    const selectedOption = options.find(option => option.id === selectedId)
    onChange(selectedOption)
  }, [selectedSeatsOption, onChange, options])

  const _handleOnChange = item => {
    const [selectedId] = item.value
    setSelectedSeatsOption([selectedId])
  }

  const filters = [
    {
      name: filterName,
      options,
      type: filterBasicTypes.SINGLE_SELECTION_OUTLINED
    }
  ]

  return (
    <FilterWrapperBasic
      filters={filters}
      group={`${filterName}Group`}
      legend="Asientos"
      onChange={_handleOnChange}
      value={{[filterName]: selectedSeatsOption}}
      wrapper={filterWrapperBasicTypes.NONE}
    />
  )
}

SeatsFilter.propTypes = {
  value: PropTypes.array,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}
